export enum CommonRoutes {
  Home = '/',
  Login = '/login',
  Logout = '/logout',
  RewardBenchmarking = '/pay-analytics/reward-benchmark',
  payAnalytics = '/payanalytics',
  myReports = '/pay-analytics/my-reports',
  singleJobPricing = '/sjpr',
  sjprSearchResults = '/sjpr/job-search-results',
  sjprPricingDetails = '/sjpr/job-pricing-details',
}
